import TypeAnnoncePercentages from "../../components/admin/TypeAnnoncePercentages";

function ListeTypesAnnonce() {


    return(
        <>
            <h4 className='mx-3 bg-col mt-2'>TYPES D'ANNONCES - POURCENTAGES % </h4>
           
            <div className="content">
                <TypeAnnoncePercentages/>
            </div>
        </>
    );
};

export default ListeTypesAnnonce;